import { apiRequest } from './client'

import type { HeaderResponse } from '../types/header'

export function getHeader(): Promise<HeaderResponse> {
  return apiRequest<HeaderResponse>('/api/v1/header')
}
